<template>
  <div>
    <my-header></my-header>

    <div class="content-container-level-1">
      <div
        v-if="isButtonPanelVisible"
        class="h-panel"
      >
        <b-button
          v-if="isImportButtonVisible"
          :disabled="importing"
          @click="importContestGroup"
        >
          Import contests
        </b-button>
      </div>

      <h2>Contests import log</h2>

      <p v-if="message !== null">
        {{message}}
      </p>

      <template v-if="imports !== null && imports.length > 0">
        <contest-group-import-preview
          v-for="importObject in imports"
          :key="importObject.id"
          :importObject="importObject"
          class="mb-3"
        />
      </template>

      <loading-indicator v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import auth from '../auth.js';
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import { mayImportContestsToClickHouse } from '../model/contest.js';

import MyHeader from './Header.vue';
import LoadingIndicator from './LoadingIndicator.vue';
import ContestGroupImportPreview from './ContestGroupImportPreview.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'ContestsImportLog',

  components: {
    MyHeader,
    LoadingIndicator,
    ContestGroupImportPreview,
  },

  data() {
    return {
      actor: auth.getViewer(),

      loadState: LOAD_STATE_INIT,

      /** @type {?Object[]} */
      imports: null,

      importing: false,
    };
  },

  computed: {  
    /** @returns {boolean} */
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    /** @returns {boolean} */
    isButtonPanelVisible() {
      return this.isImportButtonVisible;
    },

    /** @returns {boolean} */
    isImportButtonVisible() {
      const actor = this.actor;
      if(actor === null) {
        return false;
      }

      return mayImportContestsToClickHouse(actor.role);
    },

    /** @returns {?string} */
    message() {
      if(this.imports !== null && this.imports.length === 0) {
        return 'No imports.';
      }
      return null;
    },
  },

  created() {
    this.loadContestsImportLog();
  },

  methods: {
    loadContestsImportLog() {
      notifier.deleteSenderNotifications(this);
      this.doLoadContestsImportLog();
    },

    doLoadContestsImportLog() {
      this.loadState = LOAD_STATE_LOADING;

      const url = '/contest_group_imports';
      HTTP.get(url)
      .then(response => {
        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const imports = data;
        imports.sort((a, b) => b.id - a.id);

        this.imports = imports;

        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(err => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(err, {sender: this});
      });
    },

    importContestGroup() {
      if(this.importing) {
        return;
      }

      notifier.deleteSenderNotifications(this);

      this.importing = true;

      HTTP.post('/import_contest_group')
      .then(() => {
        this.importing = false;
        notifier.showSuccess('Contest group imported.');
        this.doLoadContestsImportLog();
      })
      .catch(err => {
        this.importing = false;
        notifier.showError(err, {sender: this});
      });
    },
  },
}
</script>
